export default __webpack_public_path__ + "static/media/chevrolet.ff2a419f.webp";